import { axios } from '@/configs/axios.ts'
import { type CreateClientConfig } from '@/types/client.gen.ts'

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseURL: import.meta.env.VITE_STOREFRONT_API_BASE_URL || window.STOREFRONT_API_BASE_URL,
  headers: {
    common: {
      'Content-Type': 'application/json'
    }
  },
  timeout: 30000,
  axios: axios
})
